// Port of src/app/services/white-label-user.service.ts — two private fields
// with get/set accessors. Exposed as an accessor object so call sites keep the
// property semantics (`whiteLabelUser.whiteLabelEmail = '...'`).

let _whiteLabelEmail: string | undefined = undefined;
let _whiteLabelPass: string | undefined = undefined;

export const whiteLabelUser = {
  // Getter for whiteLabelEmail
  get whiteLabelEmail(): string | undefined {
    return _whiteLabelEmail;
  },

  // Setter for whiteLabelEmail
  set whiteLabelEmail(value: string | undefined) {
    _whiteLabelEmail = value?.trim(); // Optional: Trim whitespace
  },

  // Getter for whiteLabelPass
  get whiteLabelPass(): string | undefined {
    return _whiteLabelPass;
  },

  // Setter for whiteLabelPass
  set whiteLabelPass(value: string | undefined) {
    _whiteLabelPass = value;
  },
};
